<template>
  <div>
    <a-popover
      trigger="click"
      placement="bottomRight"
      overlayClassName="header-audit-todo-wrapper"
      :getPopupContainer="() => $refs.todoRef.parentElement"
      :autoAdjustOverflow="true"
      :arrowPointAtCenter="true"
      :overlayStyle="{ width: '280px', top: '50px' }"
    >
      <template slot="content">
        <a-spin :spinning="loading">
          <div class="todo-title">待办审核事项</div>
          <a-list :data-source="todoList" class="todo-list">
            <a-list-item
              v-for="item in todoList"
              :key="item.key"
              :class="item.num > 0 ? 'todo-item-active' : 'todo-item-disabled'"
              @click="goAudit(item)"
            >
              <a-list-item-meta>
                <a slot="title">
                  <span>{{ item.label }}</span>
                  <a-badge
                    :count="item.num"
                    :numberStyle="{ backgroundColor: item.num > 0 ? '#f5222d' : '#d9d9d9' }"
                    :overflowCount="999"
                    style="margin-left: 8px;"
                  />
                </a>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-spin>
      </template>
      <span class="header-audit-todo" ref="todoRef">
        <a-badge :count="total" :numberStyle="{ backgroundColor: '#f5222d' }" :overflowCount="999">
          <a-icon style="font-size: 20px;" type="notification" />
        </a-badge>
      </span>
    </a-popover>
  </div>
</template>

<script>
import { countAuditTodo } from '@/api/platform/auditTodo'

export default {
  name: 'AuditTodoIcon',
  data () {
    return {
      loading: false,
      total: 0,
      todoList: [
        { key: 'video', label: '视频审核', num: 0, path: '/app_user/article' },
        { key: 'doctor', label: '医师认证', num: 0, path: '/app_user/doctor_auth' },
        { key: 'hospital', label: '医院认证', num: 0, path: '/app_user/hospital_auth' },
        { key: 'depart', label: '科室认证', num: 0, path: '/app_user/depart_auth' }
      ]
    }
  },
  mounted () {
    this.fetchTodo()
    // 每 60 秒刷新一次待办数量
    this.timer = setInterval(() => {
      this.fetchTodo()
    }, 60000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    fetchTodo () {
      this.loading = true
      countAuditTodo().then(res => {
        const data = res.data || {}
        this.todoList.forEach(item => {
          if (item.key === 'video') item.num = data.videoNum || 0
          if (item.key === 'doctor') item.num = data.doctorAuthNum || 0
          if (item.key === 'hospital') item.num = data.hospitalAuthNum || 0
          if (item.key === 'depart') item.num = data.departAuthNum || 0
        })
        this.total = data.totalNum || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    goAudit (item) {
      if (!item.path) return
      // 外部地址（带协议）直接新标签页打开，否则在本系统路由跳转
      if (/^https?:\/\//.test(item.path)) {
        window.open(item.path)
      } else {
        this.$router.push({ path: item.path })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header-audit-todo {
  display: inline-block;
  transition: all 0.3s;
  cursor: pointer;

  span {
    vertical-align: initial;
  }
}

.todo-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.todo-list {
  .todo-item-active {
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }
  }

  .todo-item-disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>
